import { render } from "./account.svg?vue&type=template&id=61d4c4a0"
const script = {}

import exportComponent from "/buddy/bio-effect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__